import React, {Component} from 'react';
import {Grid, Row, Col, Table} from 'react-bootstrap';

import Card from 'components/Card/Card.jsx';
import Button from 'elements/CustomButton/CustomButton.jsx';

import moment from 'moment';
import 'moment-timezone';
import Moment from 'react-moment';
import fire from 'fire.js';
import JSZip from 'jszip';
import FileSaver from 'file-saver';

import SubmissionModal from 'components/SubmissionModal/SubmissionModal.jsx';

class TableList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            storageRef: null,
            downloading: {},
        };
    }

    componentWillMount() {
        let storageRef = fire.storage().ref();
        let year = this.props.school.current_year;
        let thisYearRef = storageRef.child('submissions')
            .child(this.props.schoolKey)
            .child(year);

        this.setState({storageRef: thisYearRef});
    }

    downloadSubmission(id) {
        // What do we need to do here?
        // We need to create a TXT file with the submission date.
        // We need to fetch the images and rename them.
        // We need to create a zip for the user and start it downloading.

        // Mark this as downloading.
        let dlState = this.state.downloading;
        dlState[id] = true;
        this.setState({downloading: dlState});

        let sub = this.props.submissions[id],
            zip = JSZip(),
            imageUrlPromises = sub.images.map(img => {
                return this.state.storageRef.child(id).child(img).getDownloadURL();
            });

        let safeName = 'unknown';
        if (sub.studentName) {
            safeName = sub.studentName.replace(' ', '-');
        }

        let this_ref = this;

        Promise.all(imageUrlPromises).then(urls => {
            // Now we have all the image URLs.
            // Turn those into promises with the blob data.
            let blobPromises = urls.map(url => {
                return fetch(url).then(resp => {
                    return resp.blob();
                });
            });

            // Force all the promises to resolve with the image data.
            Promise.all(blobPromises).then(blobs => {
                // We'll rename these files on the fly.
                let newFilenames = [];
                let specialInstructions = [];

                // Add each image to the zip file using a new filename.
                blobs.forEach((blob, index) => {
                    let mimeType = blob.type,
                        filename = safeName + '-' + (index + 1).toString() + '.' + mimeType.split('/')[1];

                    zip.file(filename, blob);
                    newFilenames.push(filename);

                    let orgName = sub.images[index];
                    if ('specialInstructions' in sub && orgName in sub.specialInstructions) {
                        let si = `${filename}: ${sub.specialInstructions[orgName]}`;
                        specialInstructions.push(si);
                    }
                });

                let timezone = this_ref.props.school.timezone;
                let localized = moment(sub.time * 1000).tz(timezone).format('MMM D, YYYY h:mma');
                console.log(localized);

                // Create a text file with the submission information.
                let info = `Student Name:
    ${sub.studentName}
Purchaser Name:
    ${sub.purchaserName}
Purchaser E-mail:
    ${sub.email}
Size:
    ${sub.size}
Time:
    ${localized}
Photos:
    ${newFilenames.join('\n    ')}
Special Photo Instructions:
    ${specialInstructions.join('\n    ')} 

Message:

${sub.text}
`;
                zip.file(safeName + '.txt', info);

                // Create the ZIP and save it.
                zip.generateAsync({type: 'blob'})
                    .then(function (content) {
                        // Force down of the Zip file
                        FileSaver.saveAs(content, safeName + '.zip');

                        // Mark this as downloading.
                        let dlState = this_ref.state.downloading;
                        dlState[id] = false;
                        this_ref.setState({downloading: dlState});
                    });
            });
        });
    }

    render() {
        return (
            <div className="content">
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card
                                title="Finalized Submissions"
                                category="These submissions are fully complete and paid for."
                                ctTableFullWidth ctTableResponsive
                                content={
                                    <Table striped hover>
                                        <thead>
                                        <tr>
                                            {
                                                ['Actions', 'tags', 'Student', 'Purchaser', 'Size', 'Paid', 'Time']
                                                    .map((prop, key) => {
                                                        if (prop === 'tags') {
                                                            return (
                                                                <th key={key}/>
                                                            );
                                                        }
                                                        return (
                                                            <th key={key}>{prop}</th>
                                                        );
                                                    })
                                            }
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            Object.keys(this.props.submissions)
                                                .filter(key => {
                                                    return this.props.submissions[key].finalized;
                                                })
                                                .sort((a, b) => {
                                                    let aname = this.props.submissions[a].studentName.toLowerCase(),
                                                        bname = this.props.submissions[b].studentName.toLowerCase();

                                                    if (aname < bname)
                                                        return -1;
                                                    return 1;
                                                })
                                                // .sort((a, b) => {
                                                //     return this.props.submissions[a].seen;
                                                // })
                                                .map(key => {
                                                    return (
                                                        <tr key={key}>
                                                            <td key='actions'>
                                                                <SubmissionModal
                                                                    submission={this.props.submissions[key]}
                                                                    storage={this.state.storageRef.child(key)}
                                                                    timezone={this.props.school.timezone}/>
                                                                <Button bsStyle='default' fill
                                                                        onClick={() => this.downloadSubmission(key)}>
                                                                    <i className={
                                                                        this.state.downloading[key] === true ?
                                                                            'pe-7s-refresh-2' : 'pe-7s-cloud-download'}
                                                                       id={this.state.downloading[key] === true ? 'loading' : 'download'}
                                                                       alt='download'/>
                                                                </Button>
                                                            </td>

                                                            {['tags', 'studentName', 'purchaserName', 'size', 'paid', 'time']
                                                                .map(key2 => {
                                                                    if (key2 === 'tags') {
                                                                        let content = [];
                                                                        if (this.props.submissions[key]['seen'] === false) {
                                                                            content.push('NEW');
                                                                        }
                                                                        if ('latefee' in this.props.submissions[key]
                                                                            && this.props.submissions[key]['latefee'] > 0) {
                                                                            content.push('LATE');
                                                                        }
                                                                        return (
                                                                            <td key={key2}>{content.join(' ')}</td>
                                                                        );
                                                                    }

                                                                    let val = this.props.submissions[key][key2];

                                                                    if (key2 === 'time') {
                                                                        return (
                                                                            <td key={key2}>
                                                                                <Moment unix
                                                                                        tz={this.props.school.timezone}
                                                                                        format="MMM D, h:mma">{
                                                                                    val
                                                                                }</Moment>
                                                                            </td>
                                                                        );
                                                                    } else if (key2 === 'paid') {
                                                                        let amount = val;

                                                                        return (
                                                                            <td key={key2}>${
                                                                                amount
                                                                            }</td>
                                                                        );
                                                                    } else if (key2 === 'size') {
                                                                        return (
                                                                            <td key={key2}>
                                                                                {this.props.school[val].name}
                                                                            </td>
                                                                        );
                                                                    }

                                                                    return (
                                                                        <td key={key2}>{
                                                                            val
                                                                        }</td>
                                                                    );

                                                                })
                                                            }
                                                        </tr>
                                                    )
                                                })
                                        }
                                        </tbody>
                                    </Table>
                                }
                            />
                        </Col>


                        <Col md={12}>
                            <Card
                                plain
                                title="Unfinalized Submissions"
                                category="These were only partially completed and not paid."
                                ctTableFullWidth ctTableResponsive
                                content={
                                    <Table striped hover>
                                        <thead>
                                        <tr>
                                            {
                                                ['Actions', 'Student', 'Purchaser', 'Email', 'Size', 'Time']
                                                    .map((prop, key) => {
                                                        return (
                                                            <th key={key}>{prop}</th>
                                                        );
                                                    })
                                            }
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            Object.keys(this.props.submissions)
                                                .filter(key => {
                                                    return !this.props.submissions[key].finalized;
                                                })
                                                .sort((a, b) => {
                                                    // Named ones go up top. The rest go by time.
                                                    let aname = this.props.submissions[a].studentName,
                                                        bname = this.props.submissions[b].studentName;

                                                    if (aname !== undefined && bname !== undefined) {
                                                        if (aname < bname)
                                                            return -1;
                                                        return 1;
                                                    } else if (aname !== undefined) {
                                                        return -1;
                                                    } else if (bname !== undefined) {
                                                        return 1;
                                                    }

                                                    let atime = this.props.submissions[a].time,
                                                        btime = this.props.submissions[b].time;
                                                    return atime - btime;
                                                })
                                                .map(key => {
                                                    return (
                                                        <tr key={key}>
                                                            <td key='actions'>
                                                                <SubmissionModal
                                                                    submission={this.props.submissions[key]}
                                                                    storage={this.state.storageRef.child(key)}
                                                                    timezone={this.props.school.timezone}/>
                                                                <Button bsStyle='default' fill
                                                                        onClick={() => this.downloadSubmission(key)}>
                                                                    <i className={
                                                                        this.state.downloading[key] === true ?
                                                                            'pe-7s-refresh-2' : 'pe-7s-cloud-download'}
                                                                       id={this.state.downloading[key] === true ? 'loading' : 'download'}
                                                                       alt='download'/>
                                                                </Button>
                                                            </td>

                                                            {['studentName', 'purchaserName', 'email', 'size', 'time']
                                                                .map(key2 => {
                                                                    if (key2 === 'time') {
                                                                        return (
                                                                            <td key={key2}>
                                                                                <Moment unix
                                                                                        tz={this.props.school.timezone}
                                                                                        format="MMM D, h:mma">{
                                                                                    this.props.submissions[key][key2]
                                                                                }</Moment>
                                                                            </td>
                                                                        )
                                                                    } else if (key2 === 'size') {
                                                                        let val = this.props.submissions[key][key2];
                                                                        return (
                                                                            <td key={key2}>
                                                                                {this.props.school[val].name}
                                                                            </td>
                                                                        );
                                                                    }

                                                                    return (
                                                                        <td key={key2}>{
                                                                            this.props.submissions[key][key2]
                                                                        }</td>
                                                                    );
                                                                })
                                                            }</tr>
                                                    )
                                                })
                                        }
                                        </tbody>
                                    </Table>
                                }
                            />
                        </Col>

                    </Row>
                </Grid>
            </div>
        );
    }
}

export default TableList;



// WEBPACK FOOTER //
// ./src/views/TableList/TableList.jsx